import * as SettingsAPI from 'api/settings';
import { call, put, select } from 'redux-saga/effects';
import { getUserData } from 'sagas/profile';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators as settingsAC } from 'store/settings';

// Settings
export function* updateSettings(action: any) {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkSaveRequestError());
	}

	try {
		yield call(SettingsAPI.updateSettings, action.settings);
		yield put(settingsAC.doUpdateSettingsSuccess(action.key, action.settings));
		yield getUserData({
			force: true,
			preventUpdateLoadingState: true,
		});
	} catch (e) {
		yield put(settingsAC.doUpdateSettingsFailure(e));
	}
}
